module.exports = __webpack_public_path__ + "static/media/loupe-dark.246aa3d1.svg";